<template>
  <v-container>
    <homepage-video :video="video" v-if="video" />
    <v-layout row wrap>
      <v-flex lg12 md12 sm12 xs12 :class="['pa-2']">
        <static-page-content hidden-seo-block slug="index" :class="['title', 'font-weight-light', 'about']" />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'PageIndex',
  mixins: [
    methods
  ],
  data () {
    return {
      video: null
    }
  },
  mounted () {
    this.getRandomVideo('homepageVideos', 'onHomePage')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/index.vue